import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const baseProps = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  strokeWidth: 1.8,
};

export const HomeNavIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M3 10.5 12 3l9 7.5" />
    <path
      {...baseProps}
      d="M5.25 9.75V20.25H9.75V14.25H14.25V20.25H18.75V9.75"
    />
  </svg>
);

export const ChatNavIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      {...baseProps}
      d="M5 4.5h14A2.5 2.5 0 0 1 21.5 7v7A2.5 2.5 0 0 1 19 16.5H10l-4.5 3v-3H5A2.5 2.5 0 0 1 2.5 14V7A2.5 2.5 0 0 1 5 4.5Z"
    />
  </svg>
);

export const CalendarNavIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M7.5 3.75V6.75" />
    <path {...baseProps} d="M16.5 3.75V6.75" />
    <path {...baseProps} d="M4.5 8.25H19.5" />
    <rect {...baseProps} x="3.5" y="5.25" width="17" height="15.25" rx="2.75" />
  </svg>
);

export const DashboardNavIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <rect {...baseProps} x="3.5" y="3.5" width="7.5" height="9.5" rx="1.75" />
    <rect {...baseProps} x="13" y="3.5" width="7.5" height="5.5" rx="1.75" />
    <rect {...baseProps} x="13" y="11" width="7.5" height="9.5" rx="1.75" />
    <rect {...baseProps} x="3.5" y="15" width="7.5" height="5.5" rx="1.75" />
  </svg>
);

export const ProfileNavIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <circle {...baseProps} cx="12" cy="8" r="4.25" />
    <path {...baseProps} d="M4.75 19.75a7.25 7.25 0 0 1 14.5 0" />
  </svg>
);

export const BellNavIcon = (props: IconProps) => (
 <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3.75C9.1 3.75 6.75 6.1 6.75 9V10.29C6.75 11.07 6.43 12.18 6.04 12.84L5.09 14.43C4.51 15.4 4.91 16.48 5.98 16.84C9.96 18.17 14.03 18.17 18.01 16.84C19.01 16.51 19.44 15.33 18.9 14.43L17.95 12.84C17.56 12.18 17.24 11.07 17.24 10.29V9C17.25 6.1 14.9 3.75 12 3.75Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.85 3.98C13.54 3.89 13.22 3.82 12.89 3.78C11.93 3.66 11.01 3.73 10.15 3.98C10.44 3.24 11.17 2.72 12 2.72C12.83 2.72 13.56 3.24 13.85 3.98Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M14.25 19C14.25 20.24 13.24 21.25 12 21.25C11.38 21.25 10.81 20.99 10.41 20.59C10.01 20.19 9.75 19.62 9.75 19"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
);

export const ChevronDownIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="m7 10 5 5 5-5" />
  </svg>
);

export const ArrowRightLineIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M5 12h14" />
    <path {...baseProps} d="m13.5 6.75 5.25 5.25-5.25 5.25" />
  </svg>
);

export const CalendarMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path {...baseProps} d="M6 2.75v2.25" />
    <path {...baseProps} d="M14 2.75v2.25" />
    <path {...baseProps} d="M3.25 7H16.75" />
    <rect {...baseProps} x="2.25" y="4.5" width="15.5" height="12.5" rx="2.2" />
  </svg>
);

export const ClockMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 20 20" {...props}>
    <circle {...baseProps} cx="10" cy="10" r="7" />
    <path {...baseProps} d="M10 6.5v3.8l2.7 1.6" />
  </svg>
);

export const GuestsMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 20 20" {...props}>
    <circle {...baseProps} cx="7" cy="7.25" r="2.25" />
    <circle {...baseProps} cx="13.25" cy="8.25" r="1.75" />
    <path {...baseProps} d="M3.75 15.5a3.75 3.75 0 0 1 6.5-2.55" />
    <path {...baseProps} d="M11.25 15.5a3 3 0 0 1 5-2.25" />
  </svg>
);

export const PinMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      {...baseProps}
      d="M10 17s4.5-4.43 4.5-8.13a4.5 4.5 0 1 0-9 0C5.5 12.57 10 17 10 17Z"
    />
    <circle {...baseProps} cx="10" cy="8.75" r="1.6" />
  </svg>
);

export const CalendarAddIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M7 3.75v3" />
    <path {...baseProps} d="M17 3.75v3" />
    <path {...baseProps} d="M4.5 8.25h15" />
    <rect {...baseProps} x="3.5" y="5.25" width="17" height="15.25" rx="2.75" />
    <path {...baseProps} d="M12 11.25v5.5" />
    <path {...baseProps} d="M9.25 14h5.5" />
  </svg>
);

export const WalletMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      {...baseProps}
      d="M5 7.25h12.5A2.5 2.5 0 0 1 20 9.75v8A2.5 2.5 0 0 1 17.5 20.25H6.5A2.5 2.5 0 0 1 4 17.75v-8a2.5 2.5 0 0 1 2.5-2.5Z"
    />
    <path {...baseProps} d="M16.5 13H20" />
    <path {...baseProps} d="M6.25 7.25V6.5A2.75 2.75 0 0 1 9 3.75h8" />
  </svg>
);

export const DownloadMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M12 4.75v9.5" />
    <path {...baseProps} d="m8.5 10.75 3.5 3.5 3.5-3.5" />
    <path {...baseProps} d="M5.5 18.25h13" />
  </svg>
);

export const BreadCrumbChevronIcon = (props: IconProps) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path {...baseProps} d="m7 4.75 5 5.25-5 5.25" />
  </svg>
);

export const PencilMiniIcon = (props: IconProps) => (
  <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.26 3.84L5.05 12.53C4.74 12.86 4.44 13.51 4.38 13.96L4.01 17.2C3.88 18.37 4.72 19.17 5.88 18.97L9.1 18.42C9.55 18.34 10.18 18.01 10.49 17.67L18.7 8.98C20.12 7.48 20.76 5.77 18.55 3.68C16.35 1.61 14.67 2.34 13.26 3.84Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M11.89 5.29C12.32 8.05 14.56 10.16 17.34 10.42"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
);

export const GlobeMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <circle {...baseProps} cx="12" cy="12" r="8.25" />
    <path {...baseProps} d="M3.75 12h16.5" />
    <path
      {...baseProps}
      d="M12 3.75c2.35 2.2 3.75 5.1 3.75 8.25S14.35 18.05 12 20.25C9.65 18.05 8.25 15.15 8.25 12S9.65 5.95 12 3.75Z"
    />
  </svg>
);

export const NotificationMiniIcon = (props: IconProps) => (
  <svg
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M12 3.75C9.1 3.75 6.75 6.1 6.75 9V10.29C6.75 11.07 6.43 12.18 6.04 12.84L5.09 14.43C4.51 15.4 4.91 16.48 5.98 16.84C9.96 18.17 14.03 18.17 18.01 16.84C19.01 16.51 19.44 15.33 18.9 14.43L17.95 12.84C17.56 12.18 17.24 11.07 17.24 10.29V9C17.25 6.1 14.9 3.75 12 3.75Z"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  />

  <path
    d="M14.25 19C14.25 20.24 13.24 21.25 12 21.25C11.38 21.25 10.81 20.99 10.41 20.59C10.01 20.19 9.75 19.62 9.75 19"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);

export const HeadsetMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M5.25 12a6.75 6.75 0 0 1 13.5 0" />
    <rect {...baseProps} x="4.25" y="11.25" width="3.5" height="6" rx="1.5" />
    <rect {...baseProps} x="16.25" y="11.25" width="3.5" height="6" rx="1.5" />
    <path {...baseProps} d="M19.75 17.25c0 1.66-1.34 3-3 3h-1.5" />
  </svg>
);

export const ChevronRightMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="m9 6.75 5.25 5.25L9 17.25" />
  </svg>
);

export const CheckMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="m6.75 12.5 3.5 3.5 7-7.25" />
  </svg>
);

export const MailMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <rect
      {...baseProps}
      x="3.75"
      y="5.75"
      width="16.5"
      height="12.5"
      rx="2.5"
    />
    <path
      {...baseProps}
      d="m5.25 7.75 6.04 4.6a1.2 1.2 0 0 0 1.42 0l6.04-4.6"
    />
  </svg>
);

export const PlusMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M12 6.5v11" />
    <path {...baseProps} d="M6.5 12h11" />
  </svg>
);

export const MinusMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path {...baseProps} d="M6.5 12h11" />
  </svg>
);

export const LogoutMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      {...baseProps}
      d="M10 18.25H7.75a2 2 0 0 1-2-2v-8.5a2 2 0 0 1 2-2H10"
    />
    <path {...baseProps} d="m13 15.75 3.75-3.75L13 8.25" />
    <path {...baseProps} d="M9.75 12h7" />
  </svg>
);

export const ChecklistMiniIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <rect {...baseProps} x="5.25" y="3.75" width="13.5" height="16.5" rx="2" />
    <path {...baseProps} d="M9 8.5h6" />
    <path {...baseProps} d="M9 12h6" />
    <path {...baseProps} d="M9 15.5h4" />
  </svg>
);

export const CelebrationIcon = (props: IconProps) => (
  <svg viewBox="0 0 120 120" {...props}>
    <path
      d="M56 36 81 61 48 73l8-37Z"
      fill="rgba(255,255,255,0.72)"
      stroke="currentColor"
      strokeWidth="3.25"
      strokeLinejoin="round"
    />
    <path {...baseProps} d="M72 27c6 2.75 11 7.5 14.5 13.75" />
    <path {...baseProps} d="M90 61.5c0 7.5-2.5 14.25-7 19.25" />
    <path {...baseProps} d="M33.5 45 27 39" />
    <path {...baseProps} d="M88.5 31 94 24.5" />
    <path {...baseProps} d="M74 20 76.5 11.5" />
    <path {...baseProps} d="M95.5 44.5 104 41" />
    <path {...baseProps} d="M87 82.5 93 88.5" />
    <path {...baseProps} d="M61.5 84 59 93" />
    <path {...baseProps} d="M43.5 69.5 37 75" />
    <path
      d="M66 17c11 5.25 19.25 14.5 23 26"
      stroke="#f76e11"
      strokeWidth="3.25"
      strokeLinecap="round"
    />
  </svg>
);
